import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { useForm } from 'antd/es/form/Form';
import GeneralProductInformation from './GeneralProductInformation';
import AverageTareTable from './AverageTareTable';
import WeightCalculationTable from './WeightCalculationTable';
import EquipmentDescription from './EquipmentDescription';
import SignatureDetails from './SignatureDetails';
import '../ViewInspectionData.scss';

interface IViewRecordedPricesModal {
  isModalOpen: boolean;
  onCancel: () => void;
  formData: any;
}

type RowState = {
  repeatability?: number;
  ascending?: string;
  descending?: string;
};

const ViewPrePackagedProductModal = (props: IViewRecordedPricesModal) => {
  const { t } = useTranslation(['inspection']);
  const { isModalOpen, onCancel, formData } = props;
  const [form] = useForm();

  const [tableRecords, setTableRecords] = useState<Record<number, RowState>>({});

  const topRef = useRef<HTMLDivElement | null>(null);

  const prepRecordedData = (inspectionData: any) => {
    const inspectionWithDayjsDate = {
      ...inspectionData,
      date: dayjs(inspectionData.date),
    };
    form.setFieldsValue(inspectionWithDayjsDate);
  };

  const scrollToTop = () => {
    setTimeout(() => {
      topRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 0);
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    if (!isModalOpen) {
      form.resetFields();
      return;
    }
    prepRecordedData(formData);

    const tableData = form.getFieldValue('verificationTableData');
    setTableRecords(tableData);
  }, [isModalOpen, form]);

  return (
    <Modal
      open={isModalOpen}
      onCancel={onCancel}
      footer={null}
      width={'80%'}
      destroyOnHidden
      centered
    >
      <div
        className="mt-6 flex max-h-[75vh] w-full flex-col overflow-y-auto p-2 md:mt-4"
        ref={topRef}
      >
        {/* Header */}
        <div className="flex w-full justify-center">
          <div className="mt-4 text-center">
            <h1 className="mb-2 text-2xl font-bold">{t('prePackageProductMainHeading')}</h1>
            <p>{t('prePackageProductSubHeading')}</p>
          </div>
        </div>

        {/* General Information */}
        <GeneralProductInformation t={t} form={form} isViewMode={true} />

        <AverageTareTable t={t} tareData={formData?.avgTareTableData} isViewMode={true} />

        <WeightCalculationTable
          t={t}
          weightData={formData?.weightCalculationTableData?.body}
          isViewMode={true}
          selectedUnit={formData?.weightCalculationTableData?.header?.selectedUnit}
          selectedTareOption={formData?.weightCalculationTableData?.header?.selectedTareOption}
        />

        <EquipmentDescription t={t} form={form} isViewMode={true} />

        <SignatureDetails form={form} isViewMode={true} disabled={true} />
      </div>
    </Modal>
  );
};

export default ViewPrePackagedProductModal;
